import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import ECRadialBar from "@/components/widgets/ECRadialBar.vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
import ReviewComponent from "./components/ReviewComponent.vue";
let ReviewExecutorOverView = /** @class */ (() => {
    let ReviewExecutorOverView = class ReviewExecutorOverView extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Review Overview";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                },
                {
                    text: "Reviews",
                    to: "/performance/reviews",
                },
                {
                    text: "Review Overview",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "ReviewListing",
                },
            ];
            this.cycleId = "";
            this.opeartingStepId = "";
            this.isPageLoading = false;
        }
        get executorCycle() {
            return PAReviewModule.paCycleExecutor;
        }
        onReviewCardClick(reviewId) {
            this.showReviewComponent(reviewId, false);
        }
        reviewMeetingClicked(reviewId) {
            this.showReviewComponent(reviewId, true);
        }
        showReviewComponent(reviewId, showMeetingCard) {
            let reviewComponent = this.$refs["reviewComponentRef"];
            reviewComponent.ShowReviewModalFromExecutor(reviewId, this.opeartingStepId, showMeetingCard);
        }
        handleModalClosed() {
            this.isPageLoading = true;
            PAReviewModule.GetReviewExecutorDetails({ cycleId: this.cycleId, operatingStepId: this.opeartingStepId }).then((res) => {
                if (res) {
                    this.isPageLoading = false;
                }
            });
        }
        get hasRightsForViewReviewMeeting() {
            return this.rightsHelper(this.rightsConstant.Cycle.CanManageReviewMeeting());
        }
        getReviewProgressPercentage(review) {
            return [review.percentComplete];
        }
        created() {
            this.cycleId = this.$route.params.cycleId;
            this.opeartingStepId = this.$route.params.stepId;
            this.isPageLoading = true;
            PAReviewModule.GetReviewExecutorDetails({ cycleId: this.cycleId, operatingStepId: this.opeartingStepId }).then((res) => {
                if (res) {
                    this.isPageLoading = false;
                }
            });
        }
    };
    ReviewExecutorOverView = __decorate([
        Component({
            name: "ReviewExecutorOverView",
            components: {
                Layout,
                PageHeader,
                Loader,
                ECRadialBar,
                ReviewComponent,
            },
        })
    ], ReviewExecutorOverView);
    return ReviewExecutorOverView;
})();
export default ReviewExecutorOverView;
